import { z } from 'zod';
import { coordinateSchema } from '../Shared.js';

const lineVertexSchema = z.object({
  coordinate: coordinateSchema
});
const curveVertexSchema = z.object({
  coordinate: coordinateSchema,
  curve: coordinateSchema
});
const polygonVertexSchema = z.union([
  curveVertexSchema,
  lineVertexSchema
]);
function isCurveVertex(vertex) {
  return "curve" in vertex;
}

export { curveVertexSchema, isCurveVertex, lineVertexSchema, polygonVertexSchema };
//# sourceMappingURL=PolygonVertex.js.map
